import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import styles from "../../screens/Requirement/Requirement.module.css";
import { customTextColor, formatDate, formatTime } from "../../utils/const";
import { PiFileTextThin } from "react-icons/pi";
import { PiMailboxLight } from "react-icons/pi";
import Checkbox from "@mui/material/Checkbox";
import { CiMobile3 } from "react-icons/ci";

const TimelineCard = ({
  name,
  mode,
  client,
  rate,
  salary,
  skills,
  btn1,
  btn2,
  matches,
  posted,
  jobdata,
  handleShow,
  setHotListRow,
}) => {
  const [showMore, setShowMore] = useState(false);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const navigate = useNavigate();
  const contentRef = useRef(null);

  return (
    <Box className={styles.matches_resume_result}>
      <Box>
        <Typography
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <b>Posted by : {posted} </b>
        </Typography>
        <Typography style={{ alignSelf: "flex-end" }}>
          <b>{`${formatDate(matches)} , ${formatTime(matches)}`}</b>
        </Typography>
      </Box>
      <Box sx={{ backgroundColor: "#fff !important" }}>
        <span>
          <Typography>
            Job Title:{" "}
            <b
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => {
                setHotListRow(jobdata);
                handleShow();
                localStorage.setItem(
                  "timelineJobDetails",
                  JSON.stringify({ jobdata })
                );
              }}
            >
              {name}
            </b>
          </Typography>
          <Typography>
            Mode of Hiring: <b>{mode}</b>
          </Typography>
          <Typography>
            {jobdata?.requirement_type?.includes("full_Time")
              ? "Salary"
              : "Rate"}{" "}
            :{" "}
            <b>
              {" "}
              ${salary}
              {salary > 0
                ? jobdata?.requirement_type?.includes("full_Time")
                  ? "K Yearly"
                  : " Hourly"
                : "Non Disclosed"}{" "}
            </b>
          </Typography>
          <Typography>
            Location: <b>{client}</b>
          </Typography>
          <Typography>
            Mandatory skills:{" "}
            <b
              style={{
                overflow: "hidden",
                transition: "height 0.1s ease",
                height: showMore
                  ? `${contentRef.current?.scrollHeight}px`
                  : `${contentRef.current?.firstChild?.offsetHeight}px`,
              }}
            >
              <b ref={contentRef}>
                {showMore
                  ? skills // Show full text
                  : skills?.length > 0 && `${skills?.slice(0, 50)}`}{" "}
                <a
                  onClick={() => setShowMore(!showMore)}
                  style={{
                    textDecoration: "underline",
                    color: "#4b8ae9",
                    paddingLeft: "15px",
                    fontSize: "13px",
                  }}
                >
                  {skills?.length > 20 &&
                    (showMore ? "View Less" : "View More")}
                </a>
              </b>
            </b>
          </Typography>
        </span>

        <span style={{ alignSelf: "flex-end" }}>
          {/* <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px 0 40px",
            }}
          >
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiFileTextThin style={{ fontSize: "22px" }} />
              </div>
            </Typography>

            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiMailboxLight style={{ fontSize: "22px" }} />
              </div>
            </Typography>
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <CiMobile3 style={{ fontSize: "22px" }} />
              </div>
            </Typography>
          </span> */}
          <div
            style={{
              // marginTop: "50px",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {jobdata?.total_apply_candidate_count > 0 && (
              <Typography>
                Applied :{" "}
                <span style={{ fontSize: "20px" }}>
                  <b> {jobdata?.total_apply_candidate_count}</b>
                </span>
              </Typography>
            )}

            <button
              onClick={() => {
                // navigate("/requirement-details-view", {
                //   state: { jobdata: jobdata },
                // });
                setHotListRow(jobdata);
                handleShow();
                localStorage.setItem(
                  "timelineJobDetails",
                  JSON.stringify({ jobdata })
                );
              }}
              style={{ width: "100%", marginTop: "40px" }}
            >
              {btn1}
            </button>
            {/* <button style={{ marginLeft: "10px" }}>{btn2}</button> */}
          </div>
        </span>
      </Box>
    </Box>
  );
};

export default TimelineCard;
